import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { LayoutGrid, List } from "lucide-react";
import { useTranslation } from "react-i18next";

export type ViewType = "list" | "carusel";

type ViewTypeToggleProps = {
	value: ViewType;
	onChange: (value: ViewType) => void;
};

export function ViewTypeToggle({ value, onChange }: ViewTypeToggleProps) {
	const { t } = useTranslation();

	return (
		<ToggleButtonGroup
			exclusive
			value={value}
			onChange={(_event, next: ViewType | null) => next && onChange(next)}
			className="segmented-toggle"
			aria-label={t("filters.viewType.select")}
		>
			<ToggleButton
				value="list"
				aria-label={t("filters.viewType.list")}
				data-test-id="search-view-type-list"
			>
				<List className="icon-small" />
			</ToggleButton>
			<ToggleButton
				value="carusel"
				aria-label={t("filters.viewType.carusel")}
				data-test-id="search-view-type-carusel"
			>
				<LayoutGrid className="icon-small" />
			</ToggleButton>
		</ToggleButtonGroup>
	);
}
